import { render, staticRenderFns } from "./OrderCreatePopup.vue?vue&type=template&id=500608ab&"
import script from "./OrderCreatePopup.vue?vue&type=script&lang=js&"
export * from "./OrderCreatePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports